// extracted by mini-css-extract-plugin
export default {"Group":"QrGqLUpG"};